/**
 * HeroImageLowQuality.jsx
 * Created by Stephanie Condrey on 11/28/17.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    image: PropTypes.string,
    altText: PropTypes.string,
    ariaLabel: PropTypes.string
};

const defaultProps = {
    image: `${process.env.CDN}/img/unavailable/image-unavailable.jpg`,
    altText: '',
    ariaLabel: ''
};

export default class HeroImageLowQuality extends React.PureComponent {
    render() {
        return (
            <div role="presentation" className="rec-hero-low-quality-wrap">
                <div className="rec-hero-low-quality-background" style={{ backgroundImage: `url(${this.props.image})` }} />
                <img
                    className="rec-hero-low-quality-image"
                    src={this.props.image}
                    alt={this.props.altText}
                    aria-label={this.props.ariaLabel} />
            </div>
        );
    }
}

HeroImageLowQuality.propTypes = propTypes;
HeroImageLowQuality.defaultProps = defaultProps;
